import { render } from "./Concept_page_m.vue?vue&type=template&id=51bc162a&scoped=true"
import script from "./Concept_page_m.vue?vue&type=script&lang=js"
export * from "./Concept_page_m.vue?vue&type=script&lang=js"

import "./Concept_page_m.vue?vue&type=style&index=0&id=51bc162a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51bc162a"

export default script